'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002410 from "./presto.-Register-Page-View$$anon$10.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002414 from "./presto.-Register-Page-View$$anon$14.js";
import * as $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00248 from "./presto.-Register-Page-View$$anon$8.js";
import * as $j_presto$002etypes$0024$002dCompact$002dApplication$0024 from "./presto.types$-Compact-Application$.js";
var $p;
/** @constructor */
function $c_Lpresto_RegisterPageView$$anon$7() {
  this.buR = null;
  this.buJ = null;
  this.buK = false;
  this.buS = null;
  this.buT = false;
  this.buW = null;
  this.buP = null;
  this.buQ = false;
  this.buL = null;
  this.buM = false;
  this.buN = null;
  this.buO = false;
  this.buU = false;
  this.buV = false;
  this.buR = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.buW = "CompactApplication";
}
export { $c_Lpresto_RegisterPageView$$anon$7 as $c_Lpresto_RegisterPageView$$anon$7 };
$p = $c_Lpresto_RegisterPageView$$anon$7.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_RegisterPageView$$anon$7;
/** @constructor */
function $h_Lpresto_RegisterPageView$$anon$7() {
}
export { $h_Lpresto_RegisterPageView$$anon$7 as $h_Lpresto_RegisterPageView$$anon$7 };
$h_Lpresto_RegisterPageView$$anon$7.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.J = (function() {
  return this.buR;
});
$p.L = (function() {
  if ((!this.buK)) {
    this.buJ = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.buK = true;
  }
  return this.buJ;
});
$p.O = (function() {
  if ((!this.buT)) {
    this.buS = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.buT = true;
  }
  return this.buS;
});
$p.E = (function() {
  return this.buW;
});
$p.t = (function() {
  if ((!this.buQ)) {
    this.buP = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("id", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("code", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("groups", new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon("plans", $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.buQ = true;
  }
  return this.buP;
});
$p.M = (function() {
  if ((!this.buM)) {
    this.buL = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().aa, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$00248.$c_Lpresto_RegisterPageView$$anon$8())), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sci_$colon$colon(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lio_circe_Decoder$$anon$44(new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002410.$c_Lpresto_RegisterPageView$$anon$10())), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$()))));
    this.buM = true;
  }
  return this.buL;
});
$p.Q = (function() {
  if ((!this.buO)) {
    this.buN = new $j_presto$002e$002dRegister$002dPage$002dView$0024$0024anon$002414.$c_Lpresto_RegisterPageView$$anon$14();
    this.buO = true;
  }
  return this.buN;
});
$p.w = (function() {
  if ((!this.buV)) {
    this.buU = false;
    this.buV = true;
  }
  return this.buU;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee100) => ((p) => \u03b4scrutinee100.ad7(p)))($j_presto$002etypes$0024$002dCompact$002dApplication$0024.$m_Lpresto_types$CompactApplication$())));
});
var $d_Lpresto_RegisterPageView$$anon$7 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_RegisterPageView$$anon$7, "presto.RegisterPageView$$anon$7", ({
  Q6: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_RegisterPageView$$anon$7 as $d_Lpresto_RegisterPageView$$anon$7 };
//# sourceMappingURL=presto.-Register-Page-View$$anon$7.js.map
